import PraemienData from '@/components/praemien/praemienindexbasis';
import {praemienService, DEVELOPMENT} from '@/helper/httpService';
import * as mutationTypes from "@/store/mutationTypes";
import {calculateSinglePraemie} from "@/helper/praemienHelper";
import {getAvailability} from "@/helper/availabilityHelper";
import {RIGHTS} from "@/store/user";

const state = {
  raw: {
    praemien: null,
    praemienvermieter: null
  },
  availability: null,
  tarifList: [
    { value: "basis", text: "Normal-Tarif" },
    { value: "securo", text: "SECURO" },
    { value: "securoplus", text: "SECUROplus" },
    { value: "securopremium", text: "SECUROpremium" },
    { value: "mv", text: "Mietervereins-Mitglied ohne Mietrechtsschutz vor Gericht", shortText: "MV ohne Mietrechtsschutz vor Gericht" },
    { value: "mvmg", text: "Mietervereins-Mitglied mit Mietrechtsschutz vor Gericht", shortText: "MV mit  Mietrechtsschutz vor Gericht" }
  ]
};

const getters = {
  rawPraemien: state => state.raw,
  /**
   * returned value for given key can be true, false or "schublade"
   */
  isPraemieAvailable: state => (produkt, produktlinie, sb) => {
    const availabilityKey = produktlinie + sb + produkt;
    return state.availability && state.availability[availabilityKey];
  },
  // basePraemie: state => (produkt, produktlinie, haushalt, beamter, sb, bruttojahresmiete) => {
  //   return getBasePraemieFromRaw(state.raw,  produkt, produktlinie, haushalt, beamter, sb, bruttojahresmiete);
  // },
  singlePraemie: state => (produkt, produktlinie, haushalt, beamter, sb, laufzeit, zahlweise, maklerRabatt, bruttojahresmiete, praemienMultiplier, securoFaktor, yoligrentner, yoligazubi, yoligekfz) => {
    return calculateSinglePraemie(state.raw, produkt, produktlinie, haushalt, beamter, sb, laufzeit, zahlweise, maklerRabatt, bruttojahresmiete, praemienMultiplier, yoligrentner, yoligazubi, yoligekfz, securoFaktor);
  },
  isSusAvailable: state => !!(state.availability && state.availability["EXP" + "SB300" + "S&S PBVW+SSR"])
};

const actions = {
  INIT_PRAEMIEN: function (context, payload) {
    const tarifId = (payload && payload.tarifId) ? payload.tarifId : (payload || null);
    const tarifVersion = payload && payload.tarifVersion ? payload.tarifVersion : null;
    return praemienService.getPrice(tarifId, tarifVersion)
      .then(content => {
        context.commit(mutationTypes.SET_RAW_PRAEMIEN, content);
        context.commit(mutationTypes.SET_AVAILABILITY, getAvailability(
          tarifId ? tarifId : context.rootState.user.tarifname,
          context.getters.checkAuthorization(RIGHTS.TARIFSELECTION)
        ));
        return { defaultData: false };
      })
      .catch(err => {
        console.log(`GET PRICE failed with ${err.status}: ${err.message}`);
        if (DEVELOPMENT) {
            context.commit(mutationTypes.SET_RAW_PRAEMIEN, {
              praemien: PraemienData.praemien,
              praemienvermieter: PraemienData.praemienvermieter
            });
            console.log("DEVELOPMENT Loaded Praemien from local data source.");
            context.commit(mutationTypes.SET_AVAILABILITY, getAvailability(
              tarifId ? tarifId : context.rootState.user.tarifname,
              context.getters.checkAuthorization(RIGHTS.TARIFSELECTION)
            ));
            return { defaultData: true };
        }
        throw err;
      });
  }
};

const mutations = {
  [mutationTypes.SET_RAW_PRAEMIEN](state, priceobject) {
    state.raw.praemien = priceobject.praemien;
    state.raw.praemienvermieter = priceobject.praemienvermieter;
  },
  [mutationTypes.SET_AVAILABILITY](state, availability) {
    state.availability = availability;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
